export default __webpack_public_path__ + "static/media/background.2b1255b4.jpg";